import { ReactNode, useRef } from "react";
import { IconLibraryPhoto } from "@tabler/icons-react";
import { FileType } from "../../../types/File.ts";
import { MAX_FILE_SIZE, MAX_FILES_AMOUNT } from "../../../const/enviroment.ts";
import { useAuthToken } from "../../../hooks/useAuthToken.ts";
import { UserRole } from "../../../types/User.ts";
import PopUp, { openModal } from "../../core/PopUp.tsx";

const ImageInput = ({
  children,
  onFileChange,
  maxFilesAmount = MAX_FILES_AMOUNT,
  maxFileSize = MAX_FILE_SIZE,
}: {
  children: (handleClick: () => void) => ReactNode;
  onFileChange: (files: FileType[]) => void;
  maxFilesAmount?: number;
  maxFileSize?: number;
}) => {
  const auth = useAuthToken();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = () => {
    if (!inputRef.current || !inputRef.current.files) return null;
    const files = Array.from(inputRef.current.files);
    if (!files) return null;

    let filtered = files.filter(
      (file) => file.size < MAX_FILE_SIZE * (1024 * 1024),
    );
    if (filtered.length < files.length) {
      openModal("error-file-filtered");
    }

    const localFiles = filtered.map(showLocal);
    onFileChange(localFiles);
  };

  const showLocal = (file: File): FileType => {
    return {
      uploadedBy: "",
      basename: URL.createObjectURL(file),
      local: true,
      _id: "",
    };
  };
  const isAdmin = auth.status === "ok" && auth.isRole(UserRole.Admin);
  const handleClick = () => inputRef.current && inputRef.current.click();
  return (
    <>
      <PopUp
        id={"error-files"}
        title={
          <>
            <IconLibraryPhoto />
            Zu viele Fotos
          </>
        }
      >
        Maximal {maxFilesAmount} Bilder mit insgesamt {maxFileSize} MB pro Bild
        erlaubt.
      </PopUp>
      <PopUp
        id={"error-file-filtered"}
        title={
          <>
            <IconLibraryPhoto />
            Foto zu groß
          </>
        }
      >
        Das Bild war zu groß. Maximal {maxFileSize} MB pro Bild erlaubt.
      </PopUp>
      {children(handleClick)}

      <div className="form-control">
        <input
          ref={inputRef}
          alt={"Image to be uploaded."}
          type="file"
          multiple
          className="w-0 h-0 opacity-0"
          onChange={handleFileChange}
          accept={`.jpg,.jpeg,.png,.webp${isAdmin ? ",.svg" : ""}`}
        />
      </div>
    </>
  );
};
export default ImageInput;
